import axios from 'axios';
import { common } from './common.js';

axios.defaults.withCredentials = true; //允许axios请求携带cookie等凭证
// import {
//     load
//   } from './common';
export default {
    get: async(url, param) => {
        // open loading
        // load.openLoading();
        url = process.env.BASE_API + url;
        
        if (param) {
            url += '?' + common.serialize(param);
        }
        let rconfig = {
            credentials: 'include',
            method: 'GET',
            // Headers: {
            //     'Accept': 'application/json',
            //     'Content-Type': 'application/json',
            //     'Authorization': sessionStorage.getItem('webtoken') ? sessionStorage.getItem('webtoken') : '',
            // },
            "headers": {
                // "Content-Type": "application/x-www-form-urlencoded",
                'Content-type': 'application/json',
                "Authorization": "Bearer 123456",
                "sessionInfor":sessionStorage.getItem('sessionInfor') ? sessionStorage.getItem('sessionInfor') : ''
            },
            xhrFields: {
                withCredentials: true
            },
            mode: 'cors',
            cache: 'force-cache',
        };
        console.log("sessionStorage:",sessionStorage.getItem('sessionInfor') );
        const response = await axios.get(url, rconfig);
        const result = response.data;
        // console.log(result);

        var ReturnCodeStr = result.ReturnCode;
        if (ReturnCodeStr === '5') {
            // alert('登录过期，请重新登录！');
            var startHref = window.location.href.split("#")[0];
            window.location = startHref
        } else {
            return result;
        }
    },
    postUser: async(url, data = {}) => {
        // load.openLoading();
        url = process.env.BASE_API + url;
        let rconfig = {
            credentials: 'include',
            method: 'POST',
            xhrFields: {
                withCredentials: true
            },
            "headers": {
                'Content-type': 'application/json',
                "Authorization": "Bearer 123456",
                "token": "{"+ "'TenantId':'" + sessionStorage.getItem("TenantId") + "','uid':"+sessionStorage.getItem("NumberId")+",'HeadPhotoPath':'" + sessionStorage.getItem("HeadPhotoPath") +"'}",
            },
            xhrFields: {
                withCredentials: true
            },
            mode: 'cors',
            cache: 'force-cache'
        };
        console.log(data);
        const response = await axios.post(url, data, rconfig);
        const result = response.data;
        return result;
    },
    post: async(url, data = {},temp ='') => {
        // load.openLoading();
        if(!temp){
            url = process.env.BASE_API + url;
        }else{
            url = process.env.BASE_API_ + url;
        }
        
        let rconfig = {
            credentials: 'include',
            method: 'POST',
            xhrFields: {
                withCredentials: true
            },
            // headers: {
            //     'Accept': 'application/json',
            //     'Content-type': 'application/json',
            //     'token': common.getToken(),
            //     'withCredentials': true,
            // },
            "headers": {
                'Content-type': 'application/json',
                "Authorization": "Bearer 123456",
                "sessionInfor":sessionStorage.getItem('sessionInfor') ? sessionStorage.getItem('sessionInfor') : ''
            },
            xhrFields: {
                withCredentials: true
            },
            mode: 'cors',
            cache: 'force-cache'
        };
        const response = await axios.post(url, data, rconfig);
        const result = response.data;
        return result;
    },
    postSubMqtt: async(url, data = {},temp ='') => {
        // load.openLoading();
        url = url;
        let rconfig = {
            credentials: 'include',
            method: 'POST',
            xhrFields: {
                withCredentials: true
            },
            // headers: {
            //     'Accept': 'application/json',
            //     'Content-type': 'application/json',
            //     'token': common.getToken(),
            //     'withCredentials': true,
            // },
            "headers": {
                'Content-type': 'application/json',
                "Authorization": "Bearer 123456",
                "sessionInfor":sessionStorage.getItem('sessionInfor') ? sessionStorage.getItem('sessionInfor') : ''
            },
            xhrFields: {
                withCredentials: true
            },
            mode: 'cors',
            cache: 'force-cache'
        };
        const response = await axios.post(url, data, rconfig);
        const result = response.data;
        return result;
    },
    put: async(url, data = {}) => {
        // load.openLoading();
        url = process.env.BASE_API + url;
        let rconfig = {
            credentials: 'include',
            method: 'PUT',
            xhrFields: {
                withCredentials: true
            },
            // headers: {
            //     'Accept': 'application/json',
            //     'Content-type': 'application/json',
            //     'token': common.getToken(),
            //     'withCredentials': true,
            // },
            "headers": {
                'Content-type': 'application/json',
                "Authorization": "Bearer 123456",
                "sessionInfor":sessionStorage.getItem('sessionInfor') ? sessionStorage.getItem('sessionInfor') : ''
            },
            xhrFields: {
                withCredentials: true
            },
            mode: 'cors',
            cache: 'force-cache'
        };
        console.log("put:",data);
        const response = await axios.put(url, data, rconfig);
        const result = response.data;
        return result;
    },
    delete: async(url, param) => {
        url = process.env.BASE_API + url;
        if (param) {
            url += '?' + common.serialize(param);
        }
        let rconfig = {
            credentials: 'include',
            method: 'DELETE',
            xhrFields: {
                withCredentials: true
            },
            // headers: {
            //     'Accept': 'application/json',
            //     'Content-type': 'application/json',
            //     'token': common.getToken(),
            //     'withCredentials': true,
            // },
            "headers": {
                'Content-type': 'application/json',
                "Authorization": "Bearer 123456",
                "sessionInfor":sessionStorage.getItem('sessionInfor') ? sessionStorage.getItem('sessionInfor') : ''
            },
            xhrFields: {
                withCredentials: true
            },
            mode: 'cors',
            cache: 'force-cache'
        };
        const response = await axios.delete(url, rconfig);
        const result = response.data;
        return result;
    },
    deletejava: async(url, param) => {
        url = process.env.BASE_API_Java + url;
        if (param) {
            url += '?' + common.serialize(param);
        }
        let rconfig = {
            credentials: 'include',
            method: 'DELETE',
            xhrFields: {
                withCredentials: true
            },
            // headers: {
            //     'Accept': 'application/json',
            //     'Content-type': 'application/json',
            //     'token': common.getToken(),
            //     'withCredentials': true,
            // },
            "headers": {
                'Content-type': 'application/json',
                "Authorization": sessionStorage.getItem('yt_Authorization'),
                "sessionInfor":sessionStorage.getItem('sessionInfor') ? sessionStorage.getItem('sessionInfor') : ''
            },
            xhrFields: {
                withCredentials: true
            },
            mode: 'cors',
            cache: 'force-cache'
        };
        const response = await axios.delete(url, rconfig);
        const result = response.data;
        return result;
    },
    getjava: async(url, param) => {
        // open loading
        // load.openLoading();
        url = process.env.BASE_API_Java + url;
       
        if (param) {
            url += '?' + common.serialize(param);
        }
        let rconfig = {
            credentials: 'include',
            method: 'GET',
            // Headers: {
            //     'Accept': 'application/json',
            //     'Content-Type': 'application/json',
            //     'Authorization': sessionStorage.getItem('webtoken') ? sessionStorage.getItem('webtoken') : '',
            // },
            "headers": {
                // "Content-Type": "application/x-www-form-urlencoded",
                'Content-type': 'application/json',
                "Authorization": sessionStorage.getItem('yt_Authorization'),
                "sessionInfor":sessionStorage.getItem('sessionInfor') ? sessionStorage.getItem('sessionInfor') : ''
            },
            xhrFields: {
                withCredentials: true
            },
            mode: 'cors',
            cache: 'force-cache',
        };
        // console.log("sessionStorage:",sessionStorage.getItem('sessionInfor') );
        try{
            const response = await axios.get(url, rconfig);
            const result = response.data;
            // console.log(result);
            var ReturnCodeStr = result.state;
            if(response.status != 200){
                sessionStorage.removeItem('yt_Authorization');
                // alert('登录过期，请重新登录！');
                var startHref = window.location.href.split("#")[0]+'#/LoginPro';
                window.location = startHref
            } else if ( ReturnCodeStr === 60002) {
                sessionStorage.removeItem('yt_Authorization');
                // alert('登录过期，请重新登录！');
                var startHref = window.location.href.split("#")[0]+'#/LoginPro';
                window.location = startHref
            } else {
                return result;
            }
        }catch(error){
            sessionStorage.removeItem('yt_Authorization');
            var startHref = window.location.href.split("#")[0] + '#/LoginPro';
            window.location.href = startHref;
        }
    },
    getjavafile: async(url, param) => {
        // open loading
        // load.openLoading();
        url = process.env.BASE_API_Java + url;
        
        if (param) {
            url += '?' + common.serialize(param);
        }
        let rconfig = {
            credentials: 'include',
            method: 'GET',
            // Headers: {
            //     'Accept': 'application/json',
            //     'Content-Type': 'application/json',
            //     'Authorization': sessionStorage.getItem('webtoken') ? sessionStorage.getItem('webtoken') : '',
            // },
            "headers": {
                // "Content-Type": "application/x-www-form-urlencoded",
                'Content-type': 'application/json',
                'responseType': 'arraybuffer',
                "Authorization": sessionStorage.getItem('yt_Authorization'),
                "sessionInfor":sessionStorage.getItem('sessionInfor') ? sessionStorage.getItem('sessionInfor') : ''
            },
            xhrFields: {
                withCredentials: true
            },
            mode: 'cors',
            cache: 'force-cache',
        };
        // console.log("sessionStorage:",sessionStorage.getItem('sessionInfor') );
        const response = await axios.get(url, rconfig);
        const result = response.data;
        // console.log(result);

        var ReturnCodeStr = result.state;
        if (ReturnCodeStr === 60002) {
            sessionStorage.removeItem('yt_Authorization');
            // alert('登录过期，请重新登录！');
            var startHref = window.location.href.split("#")[0]+'#/LoginPro';
            window.location = startHref
        } else {
            return result;
        }
    },
    postjava: async(url, data = {},temp ='') => {
        // load.openLoading();
        if(!temp){
            url = process.env.BASE_API_Java + url;
        }else{
            url = process.env.BASE_API_Java + url;
        }
        let rconfig = {
            credentials: 'include',
            method: 'POST',
            xhrFields: {
                withCredentials: true
            },
            "headers": {
                'Content-type': 'application/json',
                "Authorization": sessionStorage.getItem('yt_Authorization'),
                "sessionInfor":sessionStorage.getItem('sessionInfor') ? sessionStorage.getItem('sessionInfor') : ''
            },
            xhrFields: {
                withCredentials: true
            },
            mode: 'cors',
            cache: 'force-cache'
        };
        const response = await axios.post(url, data, rconfig);
        const result = response.data;
        return result;
    },
};
axios.interceptors.response.use(
    function(response) {
    return response;
}
, function(err) {
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                err.message = '请求错误(400)';
                break;
            case 401:
                err.message = '登录失效，请重新登录(401)';
                router.push('/login');
                break;
            case 403:
                err.message = '拒绝访问(403)';
                break;
            case 404:
                err.message = '请求出错(404)';
                break;
            case 408:
                err.message = '请求超时(408)';
                break;
            case 500:
                err.message = '服务器错误(500)';
                break;
            case 501:
                err.message = '服务未实现(501)';
                break;
            case 502:
                err.message = '网络错误(502)';
                break;
            case 503:
                err.message = '服务不可用(503)';
                break;
            case 504:
                err.message = '网络超时(504)';
                break;
            case 505:
                err.message = 'HTTP版本不受支持(505)';
                break;
            default:
                err.message = `连接出错(${err.response.status})!`;


        }
    } else {
        err.message = '连接服务器失败!'
    }
    return Promise.reject(err);
});


// WEBPACK FOOTER //
// ./src/assets/js/utils/request.js